<template>
  <div>
    <b-container fluid class="mt-3 pl-0 pr-0">
      <AppLoader v-if="isLoading" />
      <b-container fluid class="pl-0 pr-0" v-else>
        <b-row>
          <!-- :cols="showNavigator ? 3 : 0" -->
          <div :class="showNavigator ? 'slide-after':'slide'">
            <ComponentListView :isFormPublished="isFormPublished" />
          </div>
          <!-- :offset="showNavigator ? '' : 0" -->

          <b-col
            :cols="showNavigator && !isFormPublished ? 6 
						: showNavigator && isFormPublished ? 9
						: !showNavigator && !isFormPublished ? 9 : 12"
            id="builder"
          >
            <div class="float-right"></div>

            <div class="clearfix" />
            <div ref="dropTab" v-on:scroll="matchHeight">
              <b-button
                class="float-left mr-3 btn-sm"
                variant="outline-primary"
                @click="showNavigator=!showNavigator"
                v-if="form1.formType == 1 || form1.formType == 5"
              >
                <font-awesome-icon
                  :icon="showNavigator ? 'caret-square-left' : 'caret-square-right'"
                />
              </b-button>
              <!-- <h3>{{form1.formTitle ? form1.formTitle[selectedLanguage || 'english'] : 'Form title has not been set'}}</h3> -->

              <!-- form build view temp hidder---------------- -->
              <!-- <b-button
                class="float-right mr-3 btn-sm"
                variant="outline-dark"
                :to="form1.formType == 4 ? '/user-exam' : '/preview'"
              >
                <font-awesome-icon icon="eye" />
              </b-button> -->

              <b-button class="float-right mr-3 btn-sm" @click="onCollapseAll">
                <font-awesome-icon :icon="expand ?'plus' : 'minus'" />
                {{expand ? 'Expand All' : 'Collapse All'}}
              </b-button>
              <div class="clearfix"></div>
              <br />
              <!-- <p>{{form1.formDescription ? form1.formDescription[selectedLanguage || 'english'] : 'No Description'}}</p> -->

              <b-col v-if="form1.formType == 1 || form1.formType == 6 || form1.formType == 5 || form1.formType == 10">
                <b-button
                  v-if="form1.formType == 1 || form1.formType == 5"
                  variant="outline-dark"
                  class="float-left mr-2"
                  @click="onScrollLeft"
                >
                  <font-awesome-icon icon="angle-left" />
                </b-button>

                <b-button
                  v-if="form1.formType == 1 || form1.formType == 5 || form1.formType == 10"
                  variant="outline-dark"
                  class="float-right ml-2"
                  @click="onScrollRight"
                >
                  <font-awesome-icon icon="angle-right" />
                </b-button>
                <b-button
                  v-if="!isFormPublished"
                  variant="outline-primary"
                  class="float-right ml-2"
                  @click="addSection(form1.formSection.length,'section')"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>

                <b-dropdown
                  v-if="form1.formType == 1 || form1.formType == 5 || form1.formType == 10"
                  variant="outline-warning"
                  class="float-right ml-2"
                >
                  <b-dropdown-item-button
                    v-for="(sectionData, index) in form1.formSection"
                    :key="sectionData.id"
                    @click="setTab(index,form1.formSection.length,$event)"
                  >
                    {{sectionData.sectionTitle[selectedLanguage]}}
                    <b-badge variant="warning">{{sectionData.formElements.length}}</b-badge>
                  </b-dropdown-item-button>
                </b-dropdown>
              </b-col>

              <b-tabs
                ref="navTabs"
                id="navTabs"
                v-model="tabIndex"
                nav-class="nav-tabs-drop"
                content-class="mt-3"
              >
                <b-tab
                  v-for="(sectionData, sIndex) in form1.formSection"
                  :key="sectionData.id"
                  class="pl-3 pr-3 scrollHeight"
                >
                  <template slot="title">
                    <font-awesome-icon
                      class="mr-2 cogs"
                      icon="cog"
                      @click="openSettings(sectionData)"
                    />
                    <font-awesome-icon
                      class="mr-2"
                      icon="copy"
                      @click="onCloneSection(sectionData)"
                      v-if="form1.formType == 1 || form1.formType == 5 && !isFormPublished"
                    />
                    <strong>{{sectionData.sectionTitle[selectedLanguage]}}</strong>
                    <font-awesome-icon
                      class="ml-2 trash"
                      icon="trash"
                      @click="$bvModal.show(sectionData.id)"
                      v-if="form1.formType == 1 || form1.formType == 5 || form1.formType == 6 || form1.formType == 10  && !isFormPublished"
                    />
                  </template>

                  <p
                    v-if="!sectionData.formElements.length"
                  >Drag and drop input controls from the right panel</p>

                  <draggable
                    v-model="sectionData.formElements"
                    group="sections"
                    class="list-group"
                    ghost-class="ghost"
                  >
                    <ElementsContainer
                      v-for="(fieldData, index) in sectionData.formElements"
                      :key="index"
                      :fieldData="fieldData"
                      :isPreview="isPreview"
                      :sectionIndex="sIndex"
                      :fieldIndex="index"
                      :inputType="fieldData.inputType"
                      class="orderable"
                    />
                  </draggable>

                  <!--delete confirmation modal -->
                  <b-modal :id="sectionData.id" title="Alert!" @ok="onDeleteSection(sIndex)">
                    <p class="my-4">Confirm delete?</p>
                  </b-modal>
                </b-tab>
              </b-tabs>
            </div>
          </b-col>

          <b-col v-if="!isFormPublished">
            <b-tabs content-class="mt-3" pills>
              <b-tab title="Inputs" active>
                <InputComponents />
              </b-tab>

              <b-tab title="Html">
                <HtmlFormComponents />
              </b-tab>
              <b-tab title="Workflow">
                <WorkflowComponents />
              </b-tab>
              <b-tab title="Charts">
                <ChartsComponents />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
      <!-- show advance field options -->
      <b-modal
        ok-only
        ok-title="Close"
        size="lg"
        v-model="showSettings"
        scrollable
        title="Section Settings"
      >
        <SectionSettings :sectionData="selectedSection" />
      </b-modal>
      <b-navbar toggleable="lg" type="dark" variant="dark" class="m-0">
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="light"
                class="my-2 my-sm-0 mr-2"
                type="button"
                to="/form/intro"
              >Back</b-button>
              <b-button
                size="sm"
                variant="light"
                class="my-2 my-sm-0"
                type="button"
                to="/preview"
              >Preview</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
  </div>
</template>

<script>
import ElementsContainer from "../components/templatesConstants/elementIndex";
import { mapMutations, mapGetters, mapActions } from "vuex";
import uid from "uid";
import draggable from "vuedraggable";
import InputComponents from "../components/InputComponets";
import WorkflowComponents from "../components/WorkflowComponents";
import HtmlFormComponents from "../components/HtmlFormComponents";
import ChartsComponents from "../components/chartsComponent";
import ComponentListView from "../components/componentsListView";
import AppLoader from "../components/Loader/Loader";
import SectionSettings from "../components/sectionSettingsCompenent";
import { Helper } from "../helpers";
// import { HTTP } from "../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import Cryptr from "cryptr";

//import VueScrollTo from 'vue-scrollto';
export default {
  name: "FormBuilderContainer",
  components: {
    InputComponents,
    WorkflowComponents,
    HtmlFormComponents,
    ChartsComponents,
    SectionSettings,
    ElementsContainer,
    ComponentListView,
    draggable,
    AppLoader
  },
  data() {
    return {
      tabIndex: 1,
      showNavigator: false,
      expand: false,
      formId: null,
      showSettings: false,
      selectedSection: null,
      collapseAll: false,
      sectionLength: 0,
      tabHeight: 0,
      isFormPublished: false,
      styleObject: {
        height: "calc(100vh - 150px)",
        "overflow-y": "auto"
      },
      // isCountries
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage", "isLoading"])
    //  styleBuilderContainter(){
    //    return {
    //       'max-width': document.querySelector("#builder").clientWidth,
    //       'flex-wrap': 'nowrap',
    //       'white-space': 'nowrap',
    //       'overflow-y': 'hidden',
    //       'overflow-x': 'hidden'
    //   }
    //}
  },
  mounted() {
    this.getFormStatus();
        // alert(document.querySelector("#builder").clientWidth);
  },

  async beforeDestroy() {
    await EventBus.$emit("onAutoSaveJsonForm", true);
  },
  methods: {
    ...mapMutations(["ADD_SECTION", "TOGGLE_ALL_COLLAPSE"]),

    ...mapActions(["removeSection", "cloneSection"]),

    getFormStatus() {
      const cryptr = new Cryptr("myTotalySecretKey");
      const decryptedString = cryptr.decrypt(
        localStorage.getItem("formStatus")
      );
      this.isFormPublished = decryptedString == 1 ? true : false;
    },

    setTab(index, length, event) {
      this.tabIndex = index;

      var options = {
        container: "#navTabs",
        easing: "ease-in",

        force: true,
        cancelable: true,
        onStart: function(element) {
          // scrolling started
        },
        onDone: function(element) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: true,
        y: false
      };

      //this.$scrollTo('.nav-link.active', 1000, options)

      let content = document.querySelector(".nav-tabs-drop");
      let tabWidth = 150;
      let currentScrollPosition = content.scrollLeft;
      let containterWidth = content.clientWidth;

      //alert(content.scrollWidth);
      let left = tabWidth * index;
      content.scrollTo({
        left: left,
        behavior: "smooth"
      });
    },

    matchHeight() {
      this.tabHeight = this.$refs.dropTab.scrollTop;
    },

    onScrollLeft() {
      let content = document.querySelector(".nav-tabs-drop");
      content.scrollBy({
        left: -500,
        behavior: "smooth"
      });
    },

    onScrollRight() {
      let content = document.querySelector(".nav-tabs-drop");
      content.scrollBy({
        left: 500,
        behavior: "smooth"
      });
    },

    openSettings(sectionData) {
      this.selectedSection = sectionData;
      this.showSettings = !this.showSettings;
    },

    onCollapseAll() { 
      this.expand = this.expand ? false : true;
      this.collapseAll = !this.collapseAll;
      this.TOGGLE_ALL_COLLAPSE(this.collapseAll);
    },

    onDeleteSection(sIndex) {
      this.removeSection(sIndex);
      this.$bvModal.hide("modal-1");
      Helper.makeToast(this.$bvToast, "success", "Section deleted");
    },

    addSection(length, type) {
      if (this.form1.formType == 6 && length > 0) {
        alert("you cannot add section in this form");
        return false;
      }
      let id = uid();
      let newSection;
      let title;
      this.sectionLength = length;
      switch (type) {
        case "section":
        default:
          title = "Section " + (length + 1) + " Title";
          newSection = {
            type: "section",
            id,
            index: length,
            name: "",
            isInValid: null,
            sectionStyle: {
              backgroundColor: null,
              backgroundImage: null,
              backgroundSize: null,
              backgroundRepeat: null,
              backgroundPosition: null,
              height: null,
              width: null,
              opacity: 1,
              padding: {
                top: null,
                right: null,
                bottom: null,
                left: null
              },
              margin: {
                top: null,
                right: null,
                bottom: null,
                left: null
              },
              border: {
                top: null,
                right: null,
                bottom: null,
                left: null
              }
            },
            advance: { hideSectionTitle: false },
            isRepeatable: false,
            sectionTitle: {
              english: title
            },
            formElements: []
          };
          break;
      }
      this.ADD_SECTION(newSection);

      this.setTab(
        this.form1.formSection.length - 1,
        this.form1.formSection.length
      );
    },

    onCloneSection(section) {
      this.cloneSection(section);
    },

    // async getIsoCountries(){
    //   let token = "Bearer " + localStorage.getItem("accessToken");
    //    try {
    //     let result = await HTTP(
    //       "get", "iso-countries",
    //       null,
    //       {
    //         Authorization: token
    //       },
    //       null,
    //       true
    //     );
    //     // console.log("// console.log", result)
    //   } catch (error) {
    //     // console.log("error", error);
    //   }
    // },
    //https://rohit.ethixdevelopment.com/api/iso-countries

    // // for uploads
    // async grtPdfForms() {
    //   let token = "Bearer " + localStorage.getItem("accessToken");
    //   // console.log("this.form1", this.form1)
    //   // console.log("this.form1", this.$store.state.form1)
    //   // let company_id = this.form1.clientId;
    //   let company_id = 525;

    //   let form_type = 6;
    //   let url = `v1/getforms/${company_id}/${form_type}`;

    //   let result = await HTTP(
    //     "get",
    //     url,
    //     null,
    //     {
    //       Authorization: token
    //     },
    //     null,
    //     false
    //   );
    //   this.$store.state.pdfForms = result.data.forms;
    // }
  },
  props: {
    isPreview: Boolean
  }
};
</script>

<style>
.main-container {
  height: 100vh;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move;
}

.orderable {
  cursor: move;
}

.selected-choosen {
  cursor: move;
}

.cogs:hover {
  font-size: 18px;
  color: blueviolet;
  animation: spin 3000ms;
}

.trash:hover {
  color: red;
  font-size: 18px;
  animation: shake 350ms infinite;
  animation-timing-function: linear;
}

.nav-tabs-drop {
  max-width: calc(100% - 100px);
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: hidden;
}

@keyframes shake {
  0% {
    transform: rotate(50deg);
  }

  50% {
    transform: rotate(-50deg);
  }

  100% {
    transform: rotate(50deg);
  }
}

@keyframes spin {
  to {
    transform: rotateZ(360deg);
  }
}

.text-truncate {
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}

.scrollHeight {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.slide {
  width: 0;
  transition: width 0.1s;
}
.slide-after {
  width: 22%;
  transition: width 0.5s;
}
</style>
